module.exports = __webpack_public_path__ + "img/max-min.4afe1e65.png";